import { USER_ROLE } from '@/types/user-profile'

export const getLiveMallClubRole = (roles: number[]): USER_ROLE => {
  const rolesSet = new Set(roles)

  if (rolesSet.has(USER_ROLE.MERCHANT)) {
    return USER_ROLE.MERCHANT
  } else if (rolesSet.has(USER_ROLE.KOL)) {
    return USER_ROLE.KOL
  } else {
    return USER_ROLE.DEFAULT
  }
}
